import { getQueryParameter } from './urlHelpers';

// eslint-disable-next-line import/prefer-default-export
export const workflow = getQueryParameter('workflow');
